export default "__VITE_ASSET__781e800d__"